export default __webpack_public_path__ + "static/media/0352.b265eaca.jpg";